define("Modules/SocialFeed", [`Module`, `module`], function (Super, Self) {
	var SOURCE_NAME_MAP = {
			Instagram: `instagram`,
		},
		SOURCE_ICON_MAP = {
			Instagram: `instagram`,
		},
		SOURCE_LINK_THEME_MAP = {
			Instagram: `INSTAGRAM`,
		};

	return Super.inherit({
		namespace: Self.id,
		requires: [`XHR`],
		constructor(setup) {
			this.defaults(setup, {
				feedId: `jpcutter`,
			});

			this.data.minWidth = null; // used to avoid manipulating the DOM unnecessarily in this.tabulate()

			return this.XHR.ajax({
				url: `//www.juicer.io/api/feeds/tixr_`,
				then: function (feed) {
					var posts = feed.posts.items.slice(0, 14);

					this.find(posts, function (post, i) {
						var source = post.source.source;

						post.index = i;
						post.sourceType = source;
						post.icon = SOURCE_ICON_MAP[source];
						post.linkTheme = SOURCE_LINK_THEME_MAP[source];
					});

					this.data.posts = posts;

					this.render();
					this.show({
						done: true,
					});
				},
			});
		},
		listeners: [
			{
				event: `click`,
				filter: `[action="load-image"]`,
				handler(evt) {
					const { data } = this;
					const index = this.parseInt(evt.currentTarget.getAttribute(`index`));

					const mappedMedia = data.posts.map((post) => {
						const sourceLabel = post.source.source;

						return {
							type: `IMAGE`,
							url: post.image,
							sourceLabel,
							sourceIcon: SOURCE_NAME_MAP[sourceLabel],
							caption: post.message,
							link: post.full_url,
							linkTheme: post.linkTheme,
						};
					});

					this.App.loadOverlay({
						type: `MediaScroller`,
						setup: {
							startIndex: index,
							media: mappedMedia,
							centerMobileContentVertically: false,
						},
						done: true,
					});
				},
			},
		],
	});
});

define("Modules/SocialFeed.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/SocialFeed/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div style=\"background-image:url('"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"image") : depth0), depth0))
    + "');\"> <a href=\"#\" action=\"load-image\" index=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"index") : depth0), depth0))
    + "\" aria-label=\"view image\"></a> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias3,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),"source",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":199},"end":{"line":1,"column":224}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"message") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":225},"end":{"line":1,"column":289}}})) != null ? stack1 : "")
    + " </div> ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"caption\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"message") : depth0), depth0)) != null ? stack1 : "")
    + "</div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"wrapper\"> <div class=\"posts primary\"> "
    + ((stack1 = lookupProperty(helpers,"slice").call(alias1,(depth0 != null ? lookupProperty(depth0,"posts") : depth0),0,7,{"name":"slice","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":50},"end":{"line":1,"column":307}}})) != null ? stack1 : "")
    + " </div> </div> <div class=\"wrapper hide-mobile\"> <div class=\"posts secondary\"> "
    + ((stack1 = lookupProperty(helpers,"slice").call(alias1,(depth0 != null ? lookupProperty(depth0,"posts") : depth0),7,14,{"name":"slice","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":386},"end":{"line":1,"column":644}}})) != null ? stack1 : "")
    + " </div> </div>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=SocialFeed.js.map